import React from 'react'
import { Box } from "grommet"
import TTabSub from '../common/TTabSub'
import { useBouncerDiagnosticsStatus } from '../bouncer/BouncerDiagnostics'

// TODO: Need to add/update this as we grow the list of applications
//       integrated with ControlCenter
export const AWS_VIEW = [
    'ttus', 'pds', 'ttw', 'hds', 'rest_api', 'score', 'schedules', 'ttid', 'billing', 'algostore', 'ledgerslsservices', 'tds'
]

const HealthStatusNodesTab = ({ serviceGroupSelected, setSelectedSubTab, selectedSubTab }) => {

    let bouncerDiagAlert = useBouncerDiagnosticsStatus(serviceGroupSelected)
    let bouncerDiagHealthColor = bouncerDiagAlert ? "ttpartial" : "light-3"

    const bouncerDiagEnvironments = [
        "ext-uat",
        "ext-prod",
        "ext-lite",
        "local-prod",
        "local-lite",
        //"local"
    ]



    const SERVICES_IN_GROUP = [
        'price_server'
    ]

    const CRYPTO_IN_GROUP = [
        'bouncer', 'oc'
    ]

    const CLUSTER_VIEW = [
        'bouncer', 'stager'
    ]

    const OC_CLUSTER_VIEW = [
        'oc'
    ]

    const INIT = [
        'fixadapter-fixdropcopy-node',
        'fixadapter-fixinbounddropcopy-node'
    ]

    const HA_VIEW = [
        'fixadapter-fixorderrouting-node',
        'edgeserver',
        'fixadapter-fixmarketdata-node',
        'fixadapter-fixdropcopy-node',
        'options'
    ]

    const DC_MARKET_VIEW = [
        'bouncer', 'stager'
    ]

    const INSTANCE_VIEW = [
        'ase', 'algoserver_exec', 'aggregator', 'algo_ng_canvas', 'algo_ng_exec'
    ]

    const ALGO_MARKET_VIEW = [
        'ase', 'algoserver_exec', 'algo_ng_canvas', 'algo_ng_exec'
    ]

    const NO_VERSIONS_APP = [
        'edgeproxy', 'stress_fa', 'positions_relay'
    ]

    const MARKET_FEED_VIEW = [
        'depth_collector', 'dynamo_collector', 'rdc', 'price_server',
    ]

    const MARKET_VIEW = [
        'epiqs', 'PIQ_FEEDER', 'aggregator', 'TTINT', 'MarketImpactServer', 'sdkalgo'
    ]

    const MARKET_VIEW_PS = [
        'mds_stream_manager'
    ]

    const BANKALGO = [
        'fixgworders',
    ]

    const BOUNCER_VIEW = [
        'bouncer'
    ]


    if (serviceGroupSelected === 'all') {
        setSelectedSubTab('ServiceGroups')
        return (
            <Box></Box>
        )
    }
    else {
        return (
            <Box
                gap='none'
                pad='none'
                direction='row'
                align='start'
                justify='start'
            >
                {
                    AWS_VIEW.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="AWS" handleClickSubTab={() => setSelectedSubTab("AWS")} selected={selectedSubTab === "AWS"} />
                }

                <TTabSub subTabName="Nodes" handleClickSubTab={() => setSelectedSubTab("Nodes")} selected={selectedSubTab === "Nodes"} />
                {
                    BOUNCER_VIEW.includes(serviceGroupSelected) && bouncerDiagEnvironments.includes(process.env.REACT_APP_ENVIRONMENT) &&
                    <TTabSub
                        subTabName="ClusterHealth" handleClickSubTab={() => setSelectedSubTab("BouncerDiag")}
                        selected={selectedSubTab === "BouncerDiag"}
                        defaultColor={bouncerDiagHealthColor}
                        selectedColor={bouncerDiagHealthColor}
                        showDiagIcon={true}
                        diagAlert={bouncerDiagAlert}
                    />
                }

                {
                    AWS_VIEW.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Regions" handleClickSubTab={() => setSelectedSubTab("Regions")} selected={selectedSubTab === "Regions"} />
                }
                {
                    !(AWS_VIEW.includes(serviceGroupSelected)) &&
                    <TTabSub subTabName="Dedicated" handleClickSubTab={() => setSelectedSubTab("Dedicated")} selected={selectedSubTab === "Dedicated"} />
                }
                {
                    CLUSTER_VIEW.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Clusters" handleClickSubTab={() => setSelectedSubTab("Clusters")} selected={selectedSubTab === "Clusters"} />
                }
                {
                    !(CLUSTER_VIEW.includes(serviceGroupSelected)) && !(AWS_VIEW.includes(serviceGroupSelected)) &&
                    <TTabSub subTabName="DCs" handleClickSubTab={() => setSelectedSubTab("DCs")} selected={selectedSubTab === "DCs"} />
                }
                {
                    (OC_CLUSTER_VIEW.includes(serviceGroupSelected)) &&
                    <TTabSub subTabName="OCCluster" handleClickSubTab={() => setSelectedSubTab("OCCluster")} selected={selectedSubTab === "OCCluster"} />
                }
                {
                    SERVICES_IN_GROUP.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Services" handleClickSubTab={() => setSelectedSubTab("Services")} selected={selectedSubTab === "Services"} />
                }
                {
                    MARKET_FEED_VIEW.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Feeds" handleClickSubTab={() => setSelectedSubTab("Feeds")} selected={selectedSubTab === "Feeds"} />
                }
                {
                    MARKET_VIEW.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Markets" handleClickSubTab={() => setSelectedSubTab("Markets")} selected={selectedSubTab === "Markets"} />
                }
                {
                    MARKET_VIEW_PS.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Markets" handleClickSubTab={() => setSelectedSubTab("PSMarkets")} selected={selectedSubTab === "PSMarkets"} />
                }
                {
                    ALGO_MARKET_VIEW.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Markets" handleClickSubTab={() => setSelectedSubTab("AlgoMarkets")} selected={selectedSubTab === "AlgoMarkets"} />
                }
                {
                    DC_MARKET_VIEW.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Markets" handleClickSubTab={() => setSelectedSubTab("DCMarkets")} selected={selectedSubTab === "DCMarkets"} />
                }
                {
                    !(NO_VERSIONS_APP.includes(serviceGroupSelected)) && !(AWS_VIEW.includes(serviceGroupSelected)) &&
                    <TTabSub subTabName="Versions" handleClickSubTab={() => setSelectedSubTab("Versions")} selected={selectedSubTab === "Versions"} />
                }
                {
                    INSTANCE_VIEW.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="InstanceID" handleClickSubTab={() => setSelectedSubTab("InstanceID")} selected={selectedSubTab === "InstanceID"} />
                }
                {
                    CRYPTO_IN_GROUP.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Crypto" handleClickSubTab={() => setSelectedSubTab("Crypto")} selected={selectedSubTab === "Crypto"} />
                }
                {
                    HA_VIEW.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="HA" handleClickSubTab={() => setSelectedSubTab("HA")} selected={selectedSubTab === "HA"} />
                }
                {
                    INIT.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Initiator" handleClickSubTab={() => setSelectedSubTab("Initiator")} selected={selectedSubTab === "Initiator"} />
                }
                {
                    BANKALGO.includes(serviceGroupSelected) &&
                    <TTabSub subTabName="Markets" handleClickSubTab={() => setSelectedSubTab("FOG Markets")} selected={selectedSubTab === "FOG Markets"} />
                }
            </Box>
        )
    }

}

export default HealthStatusNodesTab
